import * as React from 'react';
import {Navigate} from '../services/Navigator';
import { MainStyle } from '../assets/styles/MainStyle';
import { View,TextInput, TouchableOpacity, Image, Text, Alert, ScrollView, Linking} from 'react-native';
import ButtonComponent from '../components/ButtonComponent';
import printer_icon from '../assets/images/icons/print-solid-white.png';
import { getClientsBySeller, getSellerSeries, setNewOrderBySeller, updateSellerSerie, requestQRCodeCards } from '../services/ApiServices';
import { getData } from '../services/StorageService';
import user_icon from '../assets/images/icons/user-plus-solid.png';
import NavBarSeller from '../components/NavBarSeller';
import lupa_icon from '../assets/images/icons/magnifying-glass-solid.png';
import whatsapp_icon from '../assets/images/icons/whatsapp.png';
import { Base64 } from 'js-base64';
import { WebView } from 'react-native-web-webview';
export default class SerieSeller extends React.Component {
    constructor(props) {
        super(props);
        const styles = MainStyle();
        this.state = {
            redirect: {status: false, value: '/', params: null},
            webview: {visible: false, url: ""},
            styles : styles,
            user: {},
            requestLength: 0,
            systemColor: 'white',
            currentUrl: "",
            currentSystem: "",
            series: [],
            setSelected: null,
            clients: [],
            cardList: [],
            cardLength: 0,
            isLoading: false,
            code: "",
            _scrollView : null,
            isStriped : false,
            javascript_injected:   "",
            intervalCounter : 0,
            interval : null
        }
    }

    componentDidMount(){
        this.setState({isLoading : true});
        getData("current_system_color").then(res => this.setState({systemColor : res}))
        this.initializeDataState().then(res => {
            getClientsBySeller(res, this.state.user._id).then(res => this.setState({clients : res.sort(this.sortByName)}))
            getSellerSeries(res, this.state.user._id).then(res => {
                this.setState({series : Array.isArray(res)? res : []});
                if(Array.isArray(res) && res.length > 0)
                    this.setState({ javascript_injected:  `localStorage.setItem('user', ${JSON.stringify(this.state.user)}); window.location.href= ${"/imprimir-serie-qrcode?serie="+ res[0]._id }; true; // <- importante para Android não travar`})
                this.setState({isLoading : false});
                let l = 0;
                res.map(serie => {l += serie.cartelas.length});
                this.setState({cardLength : l})
            })
        })
    }

    async initializeDataState(){
        let url = await getData("current_url");
        let sys = await getData("current_system");
        this.setState({currentUrl: url, currentSystem: sys})
            
        let user = await getData(sys+"_user");
        
        this.setState({user : JSON.parse(user), javascript_injected:  `localStorage.setItem('user', ${user}); window.location.href="";true; // <- importante para Android não travar`});

        return url;
    }


    sortByName(a,b){
        if (a.nome.toLowerCase() < b.nome.toLowerCase() ) {
            return -1;
          }
          if (a.nome.toLowerCase()  > b.nome.toLowerCase() ) {
            return 1;
          }
          return 0;
    }

    submitOrder(card, client, serie, index){
        this.setState({isLoading : true});
        setNewOrderBySeller(this.state.currentUrl, {
            cartelas: [card],
            clienteId: client,
            cambistaId: this.state.user,
            gerenteId: this.state.user.tutorId,
            data: new Date()
        }).then(res => {
            serie.cartelas.splice(index,1);
            this.setState({isLoading : false});
            window.screen ? alert("Validado com sucesso!") : console.log("Validado com sucesso!");
            Alert.alert("Validado com sucesso!");
            delete this.state["client"+card.codigo];
            updateSellerSerie(this.state.currentUrl, serie);
        })

    }

    setAutoCompleteCliente(key, value){
        this.setState({[key] : {nome : value}})
    }

    scrollToRow() {
        var elIndex = 0;
        var totalIndex = 0;
        this.state.series.map((serie,sindex) => {
            serie.cartelas.map((card, index) => {
                if(card.codigo == this.state.code){
                    elIndex = totalIndex;
                }
                totalIndex += 1;
            })
        })
        this.state._scrollView.scrollTo({y: elIndex * 136,animated: true})
      }

      openURL = async (url) => {
        const supported = await Linking.canOpenURL(url);
        if (supported) {
          await Linking.openURL(url);
        } else {
          Alert.alert(`Don't know how to open this URL: ${url}`);
        }
    }

     requestCards(e){
        this.setState({isLoading: true})
        requestQRCodeCards(this.state.currentUrl, this.state.requestLength,this.state.user).then(response => {
            this.setState({cardList: [...this.state.cardList,...response.serie.cartelas], series: [response.serie], requestLength: 0}) 
            Alert.alert(response.msg);
            alert(response.msg);
            this.setState({isLoading: false})
        }).catch(err => {
            Alert.alert(`Algo não deu certo!`);
            alert(`Algo não deu certo!`);
            this.setState({isLoading: false, requestLength: 0})
        })
    }

    loadWebView(){
        this.setState({ isLoading: true, javascript_injected:  `localStorage.setItem('user', ${JSON.stringify(this.state.user)}); function goto(){window.location.href= ${"https://sf.cartelas.app/imprimir-serie-qrcode?serie="+ this.state.series[0]._id }}(); true; // <- importante para Android não travar`,  
        webview: {url: "https://sf.cartelas.app/imprimir-serie-qrcode?serie="+ this.state.series[0]._id, visible: true}})
    }

    render() {
        if(this.state.webview.visible){
            return (
                 <NavBarSeller navigation={this.props.navigation} isLoading={this.state.isLoading} >
                    {this.state.redirect.status && this.props.navigation ? <Navigate navigation={this.props.navigation} screen={this.state.redirect.value}></Navigate> : <Text></Text>}
                    <View style={{width: '100%', ...this.state.styles.col}}>
                        <View style={{width: '100%', ...this.state.styles.mt8, ...this.state.styles.row, ...this.state.styles.alignCenter, ...this.state.styles.justifyCenter}}>
                            <TouchableOpacity style={{padding: 8, ...this.state.styles.bgDark, ...this.state.styles.rounded, width: 320, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}} onPress={() => {this.setState({webview: {url: "", visible: false}})}}>
                                    <Text style={{...this.state.styles.fs18, ...this.state.styles.bold, color: 'white'}}> Fechar</Text>
                                    <Image source={printer_icon} style={{width : 22, height: 22, marginLeft: 12}} />
                            </TouchableOpacity>
                            </View>
                        <View style={{width: '100%', height: 1024}}>
                            <WebView  onLoadEnd={() => {this.setState({isLoading: false})}} source={{uri: this.state.webview.url}} injectedJavaScript={this.state.javascript_injected}  javaScriptEnabled={true}></WebView>
                        </View>
                    </View>
        
                 </NavBarSeller>
            )
        }
        else {
        return (
            <NavBarSeller navigation={this.props.navigation} isLoading={this.state.isLoading} >
            {this.state.redirect.status && this.props.navigation? <Navigate navigation={this.props.navigation} screen={this.state.redirect.value}></Navigate> : <Text></Text>}
                <View style={{height:40, ...this.state.styles.row, backgroundColor : this.state.systemColor, ...this.state.styles.justifyCenter, ...this.state.styles.alignCenter}}>
                    <Text  style={{...this.state.styles.bold, ...this.state.styles.fs14, ...this.state.styles.cLight}}>Cartelas QRCode</Text>
                </View>
                 <View style={{width: '100%', height: 48,  ...this.state.styles.mt8, ...this.state.styles.row, ...this.state.styles.alignCenter, ...this.state.styles.justifyCenter, ...this.state.styles.bgDark}}>
                    <Text style={{...this.state.styles.fs14, ...this.state.styles.bold, padding: 16, color: 'white'}}> Pedir cartelas</Text>
                 </View>
                <View style={{width: '100%', ...this.state.styles.mt8, ...this.state.styles.row, ...this.state.styles.alignCenter, ...this.state.styles.justifyCenter}}>
                    <TouchableOpacity onPress={() => { this.setState({requestLength: this.state.requestLength == 10? 0 : 10})}}><Text style={{...this.state.styles.fs14, ...this.state.styles.bold, padding: 16, backgroundColor: this.state.requestLength == 10? this.state.styles.theme.danger : this.state.styles.theme.secondary, ...this.state.styles.rounded, color: 'white'}}> 10</Text></TouchableOpacity>
                    <TouchableOpacity style={{...this.state.styles.ml16}} onPress={() => { this.setState({requestLength: this.state.requestLength == 30? 0 : 30})}}><Text style={{...this.state.styles.fs14, ...this.state.styles.bold,  padding: 16, backgroundColor: this.state.requestLength == 30? this.state.styles.theme.danger : this.state.styles.theme.secondary, ...this.state.styles.rounded, color: 'white'}}> 30</Text></TouchableOpacity>
                    <TouchableOpacity style={{...this.state.styles.ml16}} onPress={() => { this.setState({requestLength: this.state.requestLength == 50? 0 : 50})}}><Text style={{...this.state.styles.fs14, ...this.state.styles.bold,  padding: 16, backgroundColor: this.state.requestLength == 50? this.state.styles.theme.danger : this.state.styles.theme.secondary, ...this.state.styles.rounded, color: 'white'}}> 50</Text></TouchableOpacity>
                </View>
                <View style={{width: '100%', height: 48,  ...this.state.styles.mt8, ...this.state.styles.row, ...this.state.styles.alignCenter, ...this.state.styles.justifyCenter}}>
                    <TouchableOpacity disabled={this.state.requestLength == 0} style={{width: 320, backgroundColor: this.state.requestLength > 0? this.state.styles.theme.primary :  this.state.styles.theme.secondary, ...this.state.styles.rounded, ...this.state.styles.alignCenter}} onPress={this.requestCards.bind(this)}><Text style={{...this.state.styles.fs14, ...this.state.styles.bold, padding: 8, color: 'white'}}> Enviar</Text></TouchableOpacity>
                 </View>
                 {this.state.series.length > 0? 
                    <View style={{width: '100%', ...this.state.styles.mt8, ...this.state.styles.row, ...this.state.styles.alignCenter, ...this.state.styles.justifyCenter}}>
                        <TouchableOpacity style={{padding: 8, ...this.state.styles.bgSuccess, ...this.state.styles.rounded, width: 320, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}} onPress={this.loadWebView.bind(this)}>
                            <Text style={{...this.state.styles.fs18, ...this.state.styles.bold, color: 'white'}}> Imprimir {this.state.cardLength} cartelas</Text>
                            <Image source={printer_icon} style={{width : 22, height: 22, marginLeft: 12}} />
                        </TouchableOpacity>
                        
                    </View>    
                 : <View></View>}

                <View style={{width: '100%', height: 56, borderWidth: 1,  ...this.state.styles.mt8, ...this.state.styles.row, ...this.state.styles.alignCenter, ...this.state.styles.justifyCenter}}>          
                    <TextInput onChangeText={(text) => this.setState({code : text})} style={{width: '70%', height: 32, borderWidth: 1, borderColor: "gray", borderRadius: 4, paddingLeft: 12}} placeholder={"código de cartela"}></TextInput>
                    <TouchableOpacity onPress={this.scrollToRow.bind(this)}><Image  style={{marginLeft: 12, width: 24, height: 24}} source={lupa_icon}></Image></TouchableOpacity> 
                </View>
                <ScrollView   ref={view => this.setState({_scrollView : view})}  >
                <View style={{width: '100%', ...this.state.styles.mt8, ...this.state.styles.col}}>
                    {this.state.series.map((serie, sindex) => 
                        serie.cartelas.map((card,index) => {
                            this.state.isStriped = !this.state.isStriped;
                        return <View key={`${sindex}${index}`} style={{backgroundColor: this.state.isStriped ? '#e6e6ed' :'white' , borderColor: '#e6e6ed', borderWidth: 1,  width: '100%', height: 64, ...this.state.styles.mt8, ...this.state.styles.row, padding: 8, ...this.state.styles.alignCenter, ...this.state.styles.justifyCenter }}>
                            <View style={{width: '50%' , ...this.state.styles.row, justifyContent: 'center' , alignItems: 'center'}}>
                                <Text style={{...this.state.styles.bold, ...this.state.styles.cSecondary}}>{card.codigo}</Text>
                            </View>
                            <View style={{width: '50%', ...this.state.styles.col, ...this.state.styles.alignCenter, ...this.state.styles.ml8, alignItems: 'center', paddingRight: 14}}>
                                {/* <TouchableOpacity onPress={() => {this.openURL(`https://api.whatsapp.com/send?text=https://cartelas.app/?qrcode=${Base64.encode(JSON.stringify({serieId: serie._id, cartelaCodigo: card.codigo, cambistaId: this.state.user._id, currentSystem: this.state.currentSystem, currentUrl: this.state.currentUrl, systemColor: this.state.systemColor}))}`)}} >
                                    <Image source={printer_icon} style={{width : 40, height: 40}} /> 
                                </TouchableOpacity> */}
                                <TouchableOpacity onPress={() => {this.openURL(`https://api.whatsapp.com/send?text=https://cartelas.app/?qrcode=${Base64.encode(JSON.stringify({serieId: serie._id, cartelaCodigo: card.codigo, cambistaId: this.state.user._id, currentSystem: this.state.currentSystem, currentUrl: this.state.currentUrl, systemColor: this.state.systemColor}))}`)}} >
                                    <Image source={whatsapp_icon} style={{width : 32, height: 32}} /> 
                                </TouchableOpacity>
                            </View>
                        </View> 
                            })
                        )}
                </View>
                </ScrollView>         
            </NavBarSeller>
            )
        }
    }
}
